module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [_c('div', {
    class: [_vm.block + '-flex']
  }, [((_vm.data.header && !_vm.isMobile)) ? _c('div', {
    class: [_vm.block + '-left']
  }, [((_vm.data.header && !_vm.isMobile)) ? _c('div', {
    class: [_vm.block + '-header'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.block + '-right']
  }, [(_vm.pressReleases.length < 1) ? _c('div', [_c('p', {
    class: [_vm.block + '-paragraph']
  }, [_vm._v(" \n          No press releases to show at this time... please come back soon.\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.block + '-left']
  }, [((_vm.data.header && _vm.isMobile)) ? _c('div', {
    class: [_vm.block + '-header'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header)
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.pressReleases), function(pressrelease, index) {
    return _c('div', {
      class: [_vm.block + '-pressRelease']
    }, [(pressrelease.date) ? _c('div', {
      class: [_vm.block + '-date'],
      domProps: {
        "innerHTML": _vm._s(pressrelease.date)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [(pressrelease.header) ? _c('p', {
      class: [_vm.block + '-paragraph'],
      domProps: {
        "innerHTML": _vm._s(pressrelease.header)
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      class: [_vm.block + '-download']
    }, [_vm._v("\n          Download PDF: \n            "), _c('div', {
      class: [_vm.block + '-link']
    }, [(pressrelease.links.EN) ? _c('a', {
      attrs: {
        "href": pressrelease.links.EN
      }
    }, [_vm._v("English")]) : _vm._e()]), _vm._v("\n               \n            "), _c('div', {
      class: [_vm.block + '-link']
    }, [(pressrelease.links.SE) ? _c('a', {
      attrs: {
        "href": pressrelease.links.SE
      }
    }, [_vm._v("Swedish")]) : _vm._e()])])])
  })], 2)]), _vm._v(" "), (_vm.prIndex >= 0) ? _c('button-block', {
    ref: "moreButton",
    class: [_vm.block + '-button'],
    attrs: {
      "blockModifiers": ['hoverHightlight'],
      "text": "More"
    },
    nativeOn: {
      "click": function($event) {
        _vm.moreButtonClicked()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e6faa0a","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/PressReleases.vue
// module id = 505
// module chunks = 0